export const GOOGLE_OAUTH_CLIENT_ID = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID;
export const GOOGLE_OAUTH_REDIRECT_URI = process.env.REACT_APP_GOOGLE_OAUTH_REDIRECT_URI;
export const GOOGLE_OAUTH_SCOPE =
  'https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email';
